import { useKeycloak } from 'context';
import axios, { AxiosInstance } from 'axios';

type UseAxios = {
  api: AxiosInstance;
};

const api = axios.create({ baseURL: process.env.REACT_APP_DEVELOPMENT_URL });

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      // toast.error('Unauthorized');
      alert('Unauthorized');
    }
    if (error.response.status === 403) {
      // toast.error('Forbidden');
      alert('Forbidden');
    }

    return Promise.reject(error);
  }
);

const useAxios = (): UseAxios => {
  const { keycloak } = useKeycloak();

  api.interceptors.request.use(
    config => {
      const headers = { ...config.headers };
      if (keycloak.token) {
        headers.Authorization = `Bearer ${keycloak.token}`;
      }
      return { ...config, headers };
    },
    error => Promise.reject(error)
  );

  return { api };
};

export default useAxios;
